export default {
  items: [
    {
      name: 'home',
      url: '/',
      icon: 'fa fa-home',
      show: true,
      attributes: {
        exact: true
      },
    },
    {
      name: 'dashboard',
      url: '/admin/dashboard',
      icon: 'icon-speedometer',
      show: true,
      attributes: {
        exact: true
      },
    },
    {
      name: 'iam',
      icon: 'cui-people',
      code: 'base_users',
      url: '/admin/iam',
      attributes: {
        exact: true
      },
      children: [
        {
          name: 'iam',
          url: '/admin/iam',
          icon: 'cui-user',
        },
        {
          name: 'roles',
          url: '/admin/iam/roles',
          icon: 'cui-graph',
        }
      ],
      permission: ["read base_users", "see base_users"],
    },
    {
      name: 'marketplace.title',
      icon: 'cui-cart',
      url: '/admin/marketplace',
      attributes: {
        exact: true,
      },
      permission: "admin",
    },
    {
      name: 'developer',
      icon: 'bi bi-braces',
      url: '/admin/developer',
      attributes: {
        exact: true,
      },
      children: [
        {
          name: 'thunder',
          url: '/admin/thunder',
          image: '/img/templates/thunder.svg',
          permission: 'manage base_thunder'
        },
        {
          name: 'spark',
          url: '/admin/spark',
          image: '/img/templates/spark.svg',
          permission: 'manage::spark sandbox',
          integration: 'protokol-spark'
        },
        {
          name: 'forge',
          url: '/admin/forge',
          image: '/img/templates/forge.svg',
          permission: 'manage forge'
        },
        {
          name: 'functions.title',
          url: '/admin/functions',
          icon: 'bi bi-code',
          permission: 'manage base_functions'
        },
        {
          name: 'publicapp',
          url: '/admin/public-app',
          icon: 'bi bi-tablet',
          permission: 'manage base_public_apps'
        },
        {
          name: 'platformapp',
          url: '/admin/app',
          icon: 'bi bi-window',
          permission: 'manage base_platform_apps'
        },
        {
          name: 'ratchet',
          url: '/admin/ratchet',
          image: '/img/templates/ratchet.svg',
          permission: 'read base_ratchet'
        },
        {
          name: 'globalEnvironment',
          url: '/admin/environment',
          icon: 'bi bi-braces-asterisk',
          permission: 'manage global_env'
        },
        {
          name: 'integrationsLabel',
          url: '/admin/developer/integrations',
          icon: 'bi bi-puzzle',
          permission: 'manage integrations'
        },
        {
          name: 'satellites.title',
          url: '/admin/developer/satellites',
          image: '/img/templates/satellite.svg',
          permission: 'manage integrations'
        },
        {
          name: 'templatesLabel',
          url: '/admin/developer/templates',
          icon: 'bi bi-file-earmark-text',
          permission: 'manage base_templates'
        },
        {
          name: 'extensionBuilder',
          url: '/admin/developer/extension-builder',
          icon: 'bi bi-puzzle'
        }
      ],
      onlyDev: true
    },
    {
      name: 'workflow.title',
      icon: 'icon-share',
      url: '/admin/scout/workflow',
      attributes: {
        exact: true,
      },
      children: [
        {
          name: 'workflowHistory',
          url: '/admin/scout/workflow/history',
          icon: 'icon-clock',
          permission: 'manage base_workflows'
        },
        {
          name: 'runningWorkflows',
          url: '/admin/scout/workflow/running',
          icon: 'icon-control-play',
          permission: 'manage base_workflows'
        },
        {
          name: 'workflowStats',
          url: '/admin/scout/workflow/stats',
          icon: 'icon-graph',
          permission: 'manage base_workflows'
        }
      ],
      permission: 'manage base_workflows'
    },
    {
      name: 'kortex.title',
      icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="12" cy="12" r="10.5" stroke="currentColor" stroke-width="0.6" opacity="0.18"/><circle cx="12" cy="4" r="1.8" fill="currentColor"/><circle cx="4.5" cy="18" r="1.8" fill="currentColor"/><circle cx="19.5" cy="18" r="1.8" fill="currentColor"/><circle cx="12" cy="12.5" r="2.4" fill="currentColor"/><path d="M11.3 10.2 C10.8 8.2 11.2 6.3 12 5.8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M10.3 14.2 C8.5 15.6 6.3 16.8 6 16.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M13.7 14.2 C15.5 15.6 17.7 16.8 18 16.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><path d="M13.5 4.8 C17.2 7.5 20 12.5 19 16.5" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" opacity="0.28"/><path d="M10.5 4.8 C6.8 7.5 4 12.5 5 16.5" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" opacity="0.28"/><path d="M5.8 19.2 C8.2 21 15.8 21 18.2 19.2" stroke="currentColor" stroke-width="0.9" stroke-linecap="round" opacity="0.28"/></svg>',
      url: '/admin/kortex/knowledge-bases',
      permission: 'admin',
      integration: 'protokol-kortex',
      attributes: {
        exact: true,
      },
      children: [
        {
          name: 'kortex.knowledgeBases',
          url: '/admin/kortex/knowledge-bases',
          icon: 'fas fa-database',
          permission: 'admin'
        },
        {
          name: 'kortex.agents',
          url: '/admin/kortex/agents',
          icon: 'fas fa-robot',
          permission: 'admin'
        },
        {
          name: 'kortex.userAccess',
          url: '/admin/kortex/user-access',
          icon: 'fas fa-users-cog',
          permission: 'admin'
        },
        {
          name: 'kortex.usage',
          url: '/admin/kortex/usage',
          icon: 'fas fa-chart-line',
          permission: 'admin'
        },
        {
          name: 'kortex.conversations',
          url: '/admin/kortex/conversations',
          icon: 'fas fa-comments',
          permission: 'admin'
        }
      ]
    },
    {
      name: 'timber',
      url: '/admin/developer/timber',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" style="width:24px!important;height:24px!important;min-width:24px" fill="none"><path d="M22 12 C38 8,52 14,56 20L56 46C52 52,38 56,22 52Z" stroke="currentColor" stroke-width="3" stroke-linejoin="round" fill="none"/><path d="M26 16C32 15,42 16,52 20" stroke="currentColor" stroke-width="2" fill="none"/><path d="M24 24C34 21,46 23,55 28" stroke="currentColor" stroke-width="2" fill="none"/><path d="M23 33C33 30,47 31,56 35" stroke="currentColor" stroke-width="2" fill="none"/><path d="M24 41C34 39,46 40,55 43" stroke="currentColor" stroke-width="2" fill="none"/><ellipse cx="22" cy="32" rx="14" ry="20" stroke="currentColor" stroke-width="3" fill="none"/><ellipse cx="22" cy="32" rx="10" ry="15" stroke="currentColor" stroke-width="2" fill="none"/><ellipse cx="22" cy="32" rx="6" ry="10" stroke="currentColor" stroke-width="2" fill="none"/><ellipse cx="22" cy="32" rx="2.5" ry="4" fill="currentColor"/></svg>',
      permission: 'manage timber'
    }
  ]
}
